import { useCallback, useEffect, useState, useRef } from 'react';

import { useAuth } from '../context/AuthContext';
import { isAdminUser } from '../lib/userAccess';
import { readStoredTheme } from '../lib/theme';

const apiUrl = process.env.REACT_APP_BACKEND_URL;

export default function Timeliner() {
  const { token, user } = useAuth();
  const isAdmin = isAdminUser(user);
  const iframeRef = useRef(null);
  const [theme, setTheme] = useState(readStoredTheme());

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const newTheme = readStoredTheme();
      setTheme(newTheme);
      if (iframeRef.current && iframeRef.current.contentWindow) {
        iframeRef.current.contentWindow.postMessage({ type: 'THEME_CHANGE', theme: newTheme }, '*');
      }
    });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
    return () => observer.disconnect();
  }, []);

  const buildMonitorIframeSrc = useCallback((path, extraParams = {}) => {
    const base = apiUrl ? `${apiUrl}${path}` : path;
    const url = new URL(base, window.location.origin);
    if (token) {
      url.searchParams.set('token', token);
    }
    Object.entries(extraParams).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        url.searchParams.set(key, String(value));
      }
    });
    return url.toString();
  }, [token]);

  const clientId = user?.id || user?.client_id || user?.clientId || '';
  const clientParams = { ...(!isAdmin && clientId ? { client_id: clientId, client_lock: '1' } : {}), theme };

  return (
    <div className="w-full h-[calc(100vh-64px)]">
        <iframe
          ref={iframeRef}
          src={buildMonitorIframeSrc('/api/v1/monitoring/timeliner.html', clientParams)}
          width="100%"
          height="100%"
          style={{ border: 'none', display: 'block' }}
          title="Timeliner Dashboard"
        />
    </div>
  );
}
